import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Icon, Label} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl'
import {difference, getBreakResource, isNoU} from "../../utils/DBUtils";
import isFunction from "lodash/isFunction";

const MultiPlatformFieldLabel = (props) => (
  <Label basic className="db-field-label">
    {/* Show label, only include button to show other platforms if we have more than one platform, otherwise it's pointless */}
    {props.required && (props.label || props.labelKey) ?
      <i className="asterisk icon inline"/> : ''}
    {props.label ? props.label : ""}
    {props.labelKey ?
      <FormattedMessage id={props.labelKey}
                        values={{sectionIndex: props.sectionIndex + 1}}/> : ""}
    {props.numPlatforms > 2 || (props.doNotMergeMaster && props.numPlatforms === 2) ?
      <ul className="platform-icons" onClick={props.toggleOtherPlatformsVisibility}>
        {props.hasDailybreak ? <li className={"web-icon" + (props.differentDailybreak ? " different" : "")}/> : ""}
        {props.hasDemo ? <li className={"demo-icon" + (props.differentDemo ? " different" : "")}/> : ""}
        {props.hasEmbed ? <li className={"embed-icon" + (props.differentEmbed ? " different" : "")}/> : ""}
        <Icon name="chevron down"/>
      </ul>
      : ""}
  </Label>
);

MultiPlatformFieldLabel.propTypes = {
  sectionIndex: PropTypes.number,
  required: PropTypes.bool,
  label: PropTypes.any,
  labelKey: PropTypes.string,

  numPlatforms: PropTypes.number,
  doNotMergeMaster: PropTypes.bool,
  resourcePath: PropTypes.arrayOf(PropTypes.string),
  fieldPath: PropTypes.arrayOf(PropTypes.string),

  hasDailybreak: PropTypes.bool,
  hasDemo: PropTypes.bool,
  hasEmbed: PropTypes.bool,

  differentDailybreak: PropTypes.bool,
  differentEmbed: PropTypes.bool,
  differentDemo: PropTypes.bool,

  toggleOtherPlatformsVisibility: PropTypes.func,
};

function areValuesDifferent(value1, value2) {
  if (typeof value1 !== typeof value2) {
    return true;
  }

  // array comparision will check if all of the elements in one array are also in the other
  if (Array.isArray(value1) && Array.isArray(value2)) {
    if (value1.length !== value2.length) {
      return true;
    }
    let dif = difference(value1, value2);
    return dif.length > 0; // At least one value is different, so return true
  }
  return value1 !== value2;
}

const mapState = (state, ownProps) => {
  let platforms = Object.keys(state.editBreak.break || {});
  let numPlatforms = platforms.length;
  let hasDailybreak = platforms.indexOf("DAILYBREAK") !== -1;
  let hasEmbed = platforms.indexOf("EMBED") !== -1;
  let hasDemo = platforms.indexOf("DEMO") !== -1;

  let masterBreakId = state.editBreak.break.MASTER;
  let masterBreak = state.resources.resources[masterBreakId];
  let masterValue = getBreakResource(masterBreak, masterBreak, ownProps.fieldPath);

  let platformValuesDif = {};
  for (let platform of platforms) {
    let platformBreakId = state.editBreak.break[platform];
    let platformBreak = state.resources.resources[platformBreakId];
    let platformValue = getBreakResource(masterBreak, platformBreak, ownProps.fieldPath);
    platformValuesDif[platform] = areValuesDifferent(masterValue, platformValue) && !isNoU(platformValue);
  }

  let required = false;
  let label;
  let labelKey;
  if (ownProps.field) {
    required = isFunction(ownProps.field.required) ? ownProps.field.required(ownProps.formProxy) : ownProps.field.required;
    if (ownProps.field.props) {
      label =  ownProps.field.props.label;
      labelKey = ownProps.field.props.labelKey;
    }
  }

  return {
    required,
    label,
    labelKey,

    numPlatforms,
    hasDailybreak,
    hasEmbed,
    hasDemo,
    differentDailybreak: platformValuesDif["DAILYBREAK"],
    differentEmbed: platformValuesDif["EMBED"],
    differentDemo: platformValuesDif["DEMO"],
  }
};

export default connect(mapState, null)(MultiPlatformFieldLabel);


// WEBPACK FOOTER //
// ./public/components/forms/MultiPlatformFieldLabel.jsx